import React, { useMemo } from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import AdminTabelHeader from "../../../components/layout/header/AdminTabelHeader";
import { MaterialReactTable } from "material-react-table";
import useGetData from "../../../../hooks/apihooks/useGetData";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";

const AdminCubeTabel = () => {
  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetData(
    "core-values",
    "getAllCoreValue"
  );
  const reversedData = data?.sort((a, b) => b.id - a.id);
  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        id: "index",
        header: "S.No",
        size: 100,
      },
      {
        id: "image_url",
        header: "Image",
        Cell: ({ row }) => (
          <>
            <img
              src={row?.original?.image_url}
              alt="img"
              width={50}
              height={50}
            />
          </>
        ),
      },

      {
        accessorKey: "heading",
        header: "Heading",
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 400,
      },

      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <>
            <div className="flex items-center justify-around">
              <PencilIcon
                onClick={() => navigate(`edit/${row?.original?.id}`)}
                className="w-5 h-5 cursor-pointer mx-2"
              />
            </div>
          </>
        ),
      },
    ],
    []
  );
  return (
    <div>
      {" "}
      {
        isLoading && <TraingleLoading />
      }
      <AdminTabelHeader title={"3D cube"} btnStatus={false} />
      <div className="p-4">
        <MaterialReactTable
          columns={columns}
          data={reversedData || []}
          enableColumnResizing
          enableColumnOrdering
        />
      </div>
    </div>
  );
};

export default AdminCubeTabel;
